import { onTakeSnapshot, useImperativeHandle } from '@nebula.js/stardust';

const setupSnapshot = (chartInstance) => {
  onTakeSnapshot((layout) => {
    if (!chartInstance) {
      return undefined;
    }

    return chartInstance.setSnapshotData(layout);
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useImperativeHandle(
    () => ({
      getViewState() {
        if (!chartInstance) {
          return undefined;
        }
        return chartInstance.getViewState();
      },
    }),
    [chartInstance]
  );
};

export default setupSnapshot;
